<!--
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-06-21 14:27:08
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-07-06 15:48:00
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\components\xm-tenant-and-industry-form.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang="ts">
import {
  Form as AForm,
  FormItem as AFormItem,
  Select as ASelect,
  InputPassword as AInputPassword
} from 'ant-design-vue'

import {
  useXmTenantFormStore
} from '../stores/xm-tenant-form'

const {
  t
} = useI18n()

const XmAgentAndIndustryFormStore = useXmTenantFormStore()

const {
  FormRef,
  formProps,
  model
} = storeToRefs(XmAgentAndIndustryFormStore)

import {
  useXmTenantSelectStore
} from '../stores/xm-tenant-select'

const XmTenantSelectStore = useXmTenantSelectStore()

const {
  selectProps
} = storeToRefs(XmTenantSelectStore)
</script>

<template>
  <AForm v-bind="formProps" ref="FormRef">
    <AFormItem :label="t('用户')" name="tenantCode">
      <ASelect v-bind="selectProps" bordered disabled v-model:value="model.tenantCode"/>
    </AFormItem>

    <AFormItem :label="t('密码')" name="password">
      <AInputPassword v-model:value="model.password" />
    </AFormItem>
  </AForm>
</template>
